import { render } from "./EntryText.vue?vue&type=template&id=2215988a"
import script from "./EntryText.vue?vue&type=script&lang=ts"
export * from "./EntryText.vue?vue&type=script&lang=ts"

import "./EntryText.vue?vue&type=style&index=0&id=2215988a&lang=scss"
script.render = render

export default script